module.exports = __webpack_public_path__ + "img/stand_up_sign.9a6cb4fd.jpg";